import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  Container,
  Row,
  Col,
  InputGroup,
  CustomInput,
  Button,
  Label,
} from 'reactstrap';
import { Title } from '../Shared';
import { RefereeHeader } from '.';
import { refereeActions } from '../_actions';

export function DeleteTimes() {
  const dispatch = useDispatch();

  const [eventId, setEventId] = useState(0);

  const { myPastEvents, timesRecorded } = useSelector((s) => s.referee);

  useEffect(() => {
    dispatch(refereeActions.myPastEvents());
  }, [dispatch]);

  useEffect(() => {
    if (eventId) {
      dispatch(refereeActions.timesRecorded(eventId));
    }
  }, [dispatch, eventId]);

  const onDelete = (id) => {
    dispatch(refereeActions.deleteTimeRecorded(id));
  };

  return (
    <>
      <Title text="Delete Times" />
      <RefereeHeader title="Delete Times" goBack />
      <Container>
        <Row>
          <Col>
            <Label>Select an Event</Label>
            <InputGroup>
              <CustomInput
                type="select"
                id="locationSelect"
                name="locationId"
                label="whatever"
                onChange={(e) => setEventId(parseInt(e.target.value))}
                value={eventId}
                required
              >
                <option value="0">Select...</option>
                {myPastEvents.map((e, idx) => (
                  <option key={idx} value={e.id}>
                    {e.name} at {e.location.name}
                  </option>
                ))}
              </CustomInput>
            </InputGroup>
          </Col>
        </Row>
        <Row className="mt-2">
          <Col>
            <Label className="mb-2">Edit a recorded time</Label>
            {timesRecorded.map(({ id, tsDuration, user }) => {
              return (
                <TimeEntry key={id}>
                  {user.userName} - {tsDuration}
                  <Button color="primary" onClick={() => onDelete(id)}>
                    Delete
                  </Button>
                </TimeEntry>
              );
            })}
          </Col>
        </Row>
      </Container>
    </>
  );
}

const TimeEntry = ({ children }) => (
  <div
    style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      backgroundColor: '#F2F2F2',
      padding: '0.75rem',
      borderRadius: '1.5rem',
      marginBottom: '0.5rem',
    }}
  >
    {children}
  </div>
);
